import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.quotes.QuoteItemPriceAdjustView.';
  public static readonly lineItemPrice = `${Id.prefix}lineItemPrice`;
  public static readonly closeButton = `${Id.prefix}closeButton`;
  public static readonly saveButton = `${Id.prefix}saveButton`;
  public static readonly franchiseeHeading = `${Id.prefix}franchiseeHeading`;
  public static readonly quantityLabel = `${Id.prefix}quantityLabel`;
  public static readonly costPriceLabel = `${Id.prefix}costPriceLabel`;
  public static readonly subTotalLabel = `${Id.prefix}subTotalLabel`;
  public static readonly priceAdjustmentLabel = `${Id.prefix}priceAdjustmentLabel`;
  public static readonly sellPriceLabel = `${Id.prefix}sellPriceLabel`;
  public static readonly isTaxableItem = `${Id.prefix}isTaxableItem`;
  public static readonly marginLabel = `${Id.prefix}marginLabel`;
}

export class LangQuoteItemPriceAdjustView {
  private constructor() {}

  public static lineItemPrice(): string {
    return interpolate(Id.lineItemPrice);
  }

  public static closeButton(): string {
    return interpolate(Id.closeButton);
  }

  public static saveButton(): string {
    return interpolate(Id.saveButton);
  }

  public static franchiseeHeading(): string {
    return interpolate(Id.franchiseeHeading);
  }

  public static quantityLabel(): string {
    return interpolate(Id.quantityLabel);
  }

  public static costPriceLabel(): string {
    return interpolate(Id.costPriceLabel);
  }

  public static subTotalLabel(): string {
    return interpolate(Id.subTotalLabel);
  }

  public static priceAdjustmentLabel(): string {
    return interpolate(Id.priceAdjustmentLabel);
  }

  public static sellPriceLabel(): string {
    return interpolate(Id.sellPriceLabel);
  }

  public static isTaxableItem(): string {
    return interpolate(Id.isTaxableItem);
  }

  public static marginLabel(args: { calculationLabel: string; percent: string }): string {
    return interpolate(Id.marginLabel, args);
  }
}

export class QuoteItemPriceAdjustViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.lineItemPrice, 'Line Item Price', 'Dialog title for line item price adjustment');
    register.add(Id.closeButton, 'Close', 'Button to close the dialog');
    register.add(Id.saveButton, 'Save', 'Button to save changes');
    register.add(Id.franchiseeHeading, "{{glossary 'franchisee'}}", 'Heading for franchisee section');
    register.add(Id.quantityLabel, 'Quantity', 'Label for quantity field');
    register.add(Id.costPriceLabel, 'Cost Price', 'Label for cost price field');
    register.add(Id.subTotalLabel, 'Sub Total', 'Label for subtotal field');
    register.add(Id.priceAdjustmentLabel, 'Price Adjustment', 'Label for price adjustment field');
    register.add(Id.sellPriceLabel, 'Sell Price', 'Label for calculated gross selling price field');
    register.add(Id.isTaxableItem, 'Is Taxable Item', 'Label for taxable item switch');
    register.add(
      Id.marginLabel,
      '{{calculationLabel}} (default {{percent}}%)',
      'Label for margin/markup field with default percent'
    );
  }
}
